
import { mapGetters } from "vuex";
export default {
  props: {
    center: {
      default: true,
    },
    css: String,
  },
  computed: {
    ...mapGetters(["currentModalState"]),
    currentState() {
      return this.currentModalState;
    },
  },
  mounted() {
    document.body.style.setProperty("overflow", "hidden");
  },
  unmounted() {
    document.body.style.removeProperty("overflow");
  },
  methods: {
    close() {
      this.$emit("close", !this.currentModalState);
    },
    toggleModalState() {
      this.$store.commit("change", {
        type: "modalState",
        data: !this.currentModalState,
      });
    },
  },
};
